<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看直播" subheading="" />
      <div class="header-btn-box">
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">直播标题：</div>
        <div class="line-info">{{detailInfo.title || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播嘉宾：</div>
        <div class="line-info">{{detailInfo.guest || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播问答：</div>
        <div class="line-info" v-html="detailInfo.ask || '无'"></div>
      </div>
      <div class="form-line">
        <div class="line-text">直播地址：</div>
        <div v-if="detailInfo.videoLink" class="line-info" style="color: #00a0e6;cursor: pointer;" @click="seeVideo">查看</div>
        <div class="line-info" v-else>无</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播类型：</div>
        <div class="line-info">{{detailInfo.typeName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播开始时间：</div>
        <div class="line-info">{{detailInfo.startTime || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播结束时间：</div>
        <div class="line-info">{{detailInfo.endTime || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">直播状态：</div>
        <div class="line-info">{{detailInfo.statusText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">浏览量：</div>
        <div class="line-info">{{detailInfo.viewNumber || '0'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">收藏量：</div>
        <div class="line-info">{{detailInfo.collectNumber || '0'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">政策要点：</div>
        <div class="line-info">{{detailInfo.content || '无'}}</div>
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {api} from '../../api/EnterpriseFavour'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {nSuccess} from '../../../utils/notice'

  export default {
    components: {
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'live-room-current',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '惠企服务',
            name: 'latest-policy-manage'
          }, {
            value: '亲清直播间'
          }],
        },
        code: '',
        detailInfo: {}
      }
    },
    created () {
      this.code = this.$route.params.id
      this.getLiveDetail()
    },
    methods: {
      getLiveDetail () {
        this.$axios.get(`${api.getLiveDetail}/${this.code}`, {})
          .then(res => {
            let data = res.data.data
            if (data.status === '0') {
              data.statusText = '预告中'
            } else if (data.status === '1') {
              data.statusText = '直播中'
            } else if (data.status === '2') {
              data.statusText = '已结束'
            }
            this.detailInfo = data
          })
          .catch(errorHandler('获取数据失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'live-room-manage'
        })
      },
      seeVideo () {
        window.open(this.detailInfo.videoLink, '_blank')
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 30px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
  .line-info {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/view/EnterpriseFavour/LiveRoom/LiveRoomCurrent.vue